'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('CorrecaoSoloCtrl', function($scope, $rootScope, $q, filterFilter, $uibModal,
  RecomendacoesService, LoadingService, UnidadesService, MESSAGE_WITHOUT_PRODUCT,
  MessagesService, RecomendacaoObjectService, UsuariosService, MESSAGE_INVALID_PRODUCT,
  $route, $timeout, ProdutoModalService, SafrasService, DecimalsService) {
  $scope.datePickerOptions = {
    showWeeks: false
  };

  $scope.openPopupData = function(popup) {
    $scope.popupData[popup] = true;
  };

  $scope.popupData = {
    openedDataInicial: false,
    openedDataFinal: false,
    format: 'dd/MM/yyyy'
  };

  $scope.changeData = function(campoData) {
    if ($scope.recommendation.dataInicial > $scope.recommendation.dataFinal) {
      if (campoData === 'inicial') {
        $scope.recommendation.dataFinal = $scope.recommendation.dataInicial;
      } else if (campoData === 'final') {
        $scope.recommendation.dataInicial = $scope.recommendation.dataFinal;
      }
    }
  };

  const setUnidadeSelected = function(produto) {
    const unidade = produto.unidade ? (produto.unidade.descricao_padrao || produto.unidade.descricao) : null;
    produto.unidadeSelected = !unidade ? {} : UnidadesService.getMeasureUnitysFromDescription(unidade);
    if (!produto.unidadeSelected.abreviatura && unidade) {
      produto.unidadeSelected = {
        ...produto.unidade,
        conversao: 1,
        nomeSistema: +produto.unidade.id,
        nomeAbreviado: `${(produto.unidade.abreviatura || '').trim().toLowerCase()}/ha`
      };
    }
    return produto;
  };

  const setValuesSelected = function() {
    $scope.isLoadingRecommendationFromApi = true;
    resetGlebas();
    getGlebasPeriodo().then(function() {
      $scope.glebasAtividade.forEach(function(gleba) {
        const glebaFilter = filterFilter($scope.recommendation.selects.glebas, { id: gleba.id }, true)[0] || null;
        if (glebaFilter) {
          gleba.selected = true;
          gleba.area = Number(glebaFilter.area_recomendada);
          gleba.order = new Date();
        }
      });

      $scope.changeGlebasAndProdutos();
      $scope.recommendation.produtos.forEach(function(produto) {
        setUnidadeSelected(produto);
        setUnidadesProduto(produto);
      });

      $scope.glebasAtividade = _.sortBy($scope.glebasAtividade, function(item) {
        return _.findIndex($scope.recommendation.selects.glebas, (i) => i.id === item.id);
      });
    })
      .finally(function() {
        $scope.isLoadingRecommendationFromApi = false;
      });
  };

  const initializeVariables = function() {
    $scope.quantidadeTotalBloqueada = true;
    $scope.loadingSpraysGleba = 0;
    $scope.recommendation = {};
    $scope.glebasAtividade = [];
    $scope.produtos = null;
    $scope.users = [];
    $scope.atividades = [];
    $scope.gleba = {
      selected: null
    };
    $scope.produto = {
      selected: null
    };
    $scope.pressaoUnidades = UnidadesService.getPressureUnitys();
    $scope.isDecimalV2Enabled = DecimalsService.isDecimalV2Enabled();
    $scope.isLoadingRecommendationFromApi = false;
  };

  // eslint-disable-next-line max-lines-per-function
  const initialize = function(recommendation) {
    LoadingService.showLoading();

    initializeVariables();

    // eslint-disable-next-line max-lines-per-function
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.recomendacaoCorrecaoSolo.canManage) {
        LoadingService.hideLoading();
        MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.activeHistoryRecommendations = function() {
        $route.updateParams({
          activeRecommendationsTab: 'correcaoSolo'
        });
        $timeout(function() {
          $scope.$emit('activateSidebar', 'recommendations');
        });
      };

      const promises = [UsuariosService.list(), SafrasService.listAll()];

      $q.all(promises).then(function([usuarios, safras]) {
        $scope.users = (usuarios.data.length > 0) ? usuarios.data : [];
        $scope.safras = safras.data || [];

        if ((recommendation || {}).id) {
          $scope.recommendation = RecomendacaoObjectService.convertToObjectCorrecao(recommendation);
          setValuesSelected();
          LoadingService.hideLoading();
        } else {
          $scope.recommendation = {
            dataInicial: new Date(),
            dataFinal: new Date(),
            propriedade: $rootScope.currentPropriedade,
            safra: filterFilter($scope.$root.safras, { current: true })[0],
            operacao_id: $rootScope.parametros.operacao_correcao_solo.id
          };
          RecomendacoesService.getValuesDefault($scope.recommendation).then(function(data) {
            $scope.recommendation = data;
            $scope.changeSafra();
          })
            .finally(LoadingService.hideLoading);
        }
      }, LoadingService.hideLoading);
    }, $rootScope.errorRootInitialize);
  };

  $scope.fixDose = function(produto) {
    if ($scope.isDecimalV2Enabled && produto._doseOnFocus !== produto.dose) {
      produto.dose = DecimalsService.truncateDoseOrQuantity(produto.dose);
      $scope.changeDose(produto);
      delete produto._doseOnFocus;
    } else {
      produto.dose = +Number(produto.dose).toFixed(4);
    }
  };

  $scope.fixQuantidadeTotal = function(produto) {
    if ($scope.isDecimalV2Enabled && produto._qtTotalOnFocus !== produto.qtTotal) {
      produto.qtTotal = DecimalsService.truncateDoseOrQuantity(produto.qtTotal);
      $scope.changeQuantidadeTotal(produto);
      delete produto._qtTotalOnFocus;
    } else {
      produto.qtTotal = +Number(produto.qtTotal).toFixed(4);
    }
  };

  $scope.startEditDose = function(produto) {
    produto._doseOnFocus = +produto.dose;
  };

  $scope.startEditQuantidadeTotal = function(produto) {
    produto._qtTotalOnFocus = +produto.qtTotal;
  };

  function getGlebasPeriodo(propriedade, forceOnlyActive = false) {
    const deferred = $q.defer();

    if ($scope.recommendation.safra) {
      LoadingService.showLoading();
      const filters = {
        safra: ($scope.recommendation.safra || {}).id
      };

      if (propriedade) {
        filters.propriedade = propriedade.id;
      }

      if (!$scope.canEdit() && !forceOnlyActive) {
        filters.ignore_open = true;
      }

      RecomendacoesService.listGlebasAtividades(filters, propriedade).then(function(data) {
        $scope.glebasAtividade = data;
        deferred.resolve();
      }, function() {
        MessagesService.alert('Ocorreu um erro ao buscar os talhões com empreendimento da safra selecionada.');
        deferred.reject();
      })
        .finally(LoadingService.hideLoading);
    } else {
      deferred.resolve();
    }

    return deferred.promise;
  }

  $scope.changeSafra = function() {
    resetGlebas();
    getGlebasPeriodo();
  };

  function resetGlebas() {
    $scope.glebasAtividade = [];
    $scope.recommendation.gleba = null;
  }

  $scope.addGleba = function($select) {
    $scope.glebasAtividade.forEach(function(gleba) {
      if (gleba.id === $select.id) {
        gleba.selected = true;
        gleba.area = gleba.area_total;
        gleba.order = new Date();
      }
    });
    $scope.gleba.selected = null;
    $scope.changeGlebasAndProdutos();
  };

  $scope.removeGleba = function(gleba) {
    gleba.selected = false;
    $scope.changeGlebasAndProdutos();
  };

  const changeAreaTotalProdutos = function() {
    if ($scope.isDecimalV2Enabled && $scope.isLoadingRecommendationFromApi) {
      return;
    }

    if (!$scope.recommendation.produtos) {
      return;
    }
    $scope.recommendation.produtos.forEach(function(produto) {
      $scope.changeDose(produto);
    });
  };

  $scope.changeGlebasSelected = function() {
    const glebas = filterFilter($scope.glebasAtividade, { selected: true });
    const stillSelectedGlebas = filterFilter(
      ($scope.recommendation.glebas || {}).glebas || [],
      { selected: true }
    );

    if (stillSelectedGlebas.length) {
      $scope.glebasAtividade = _.sortBy($scope.glebasAtividade, (item) => {
        const index = _.findIndex(stillSelectedGlebas, ({ id }) => id === item.id);
        return index > -1 ? 0 : glebas.length;
      });
    }

    const areaTotal = glebas.reduce(function(sum, gleba) {
      return sum + Math.max(+gleba.area, 0);
    }, 0);
    $scope.recommendation.glebas = {
      glebas: glebas,
      areaTotal: $scope.isDecimalV2Enabled ? DecimalsService.truncateArea(areaTotal): areaTotal.toFixed(2)
    };

    $scope.quantidadeTotalBloqueada = glebas.length === 0;
  };

  $scope.changeGlebasAndProdutos = function() {
    $scope.changeGlebasSelected();
    changeAreaTotalProdutos();
  };

  $scope.searchProdutos = function($select) {
    $scope.searchProduto = $select.search;
    $scope.produtos = null;
    if ($scope.searchProduto.length >= 3) {
      $scope.loadingProdutos = true;
      RecomendacoesService.listItemsBalance({
        descricao: $select.search,
        operacao_item: 'correcao_solo'
      }).then(function(data) {
        $scope.produtos = data.data || [];
      })
        .catch(function(error) {
          console.error('Erro ao buscar produtos', error);
          MessagesService.alert('Erro ao carregar produtos');
        })
        .finally(function() {
          $scope.loadingProdutos = false;
        });
    }
  };

  function calculateQuantidadeTotal(area, dose) {
    const areaTotal = Math.max(+area, 0);
    if ($scope.isDecimalV2Enabled) {
      const areaTruncated = DecimalsService.truncateArea(areaTotal);
      const quantidadeTotal = DecimalsService.roundForCalculation(
        dose * areaTruncated,
        DecimalsService.DECIMAL_PLACES_CALCULATION
      );
      return DecimalsService.truncateDoseOrQuantity(quantidadeTotal);
    }

    return +Number(dose * areaTotal).toFixed(4);
  }

  $scope.changeDose = function(produto) {
    if ($scope.recommendation.glebas) {
      produto.qtTotal = calculateQuantidadeTotal($scope.recommendation.glebas.areaTotal, produto.dose);
    }
  };

  $scope.changeQuantidadeTotal = function(produto) {
    if (!$scope.recommendation.glebas) {
      return;
    }

    const areaTotal = Math.max(+$scope.recommendation.glebas.areaTotal, 0);
    if ($scope.isDecimalV2Enabled) {
      const dose = DecimalsService.roundForCalculation(
        produto.qtTotal / areaTotal,
        DecimalsService.DECIMAL_PLACES_CALCULATION
      );
      produto.dose = DecimalsService.truncateDoseOrQuantity(dose);
    } else {
      produto.dose = +Number(produto.qtTotal / areaTotal).toFixed(4);
    }
  };

  // eslint-disable-next-line complexity
  $scope.addProduto = function($select) {
    if ($select && $select.id) {
      const produto = filterFilter($scope.recommendation.produtos, { id: $select.id }, true) || [];
      if (produto && produto.length > 0) {
        MessagesService.alert('Este produto já foi inserido na recomendação atual');
      } else {
        $select.qtTotal = calculateQuantidadeTotal($scope.recommendation.glebas.areaTotal, $select.dose);
        setUnidadeSelected($select);
        setUnidadesProduto($select);
        $scope.recommendation.produtos = ($scope.recommendation.produtos || []).concat($select);
      }
    }
    $scope.produto.selected = null;
    $scope.produtos = null;
  };

  $scope.removeProduto = function(index) {
    $scope.recommendation.produtos.splice(index, 1);
  };

  $scope.setUnidadeProduto = function($event, produto, unidade) {
    $event.preventDefault();
    produto.unidadeSelected = unidade;
  };

  function setUnidadesProduto(produto) {
    produto.unidades = UnidadesService.getUnidadesCompativeis(produto.unidadeSelected);
  }

  const validateProdutos = function() {
    const produtosOriginais = $scope.recommendation.produtos || [];

    if (produtosOriginais.length === 0) {
      return { valid: false, message: MESSAGE_WITHOUT_PRODUCT };
    }

    const MIN_QT_TOTAL_VALOR = 0.0001;

    const produtosValidos = produtosOriginais.reduce(function(result, produto) {
      if (produto.dose && produto.qtTotal >= MIN_QT_TOTAL_VALOR &&
        produto.unidadeSelected && produto.unidadeSelected.conversao) {
        result.push(produto);
      }
      return result;
    }, []);

    if (produtosValidos.length < produtosOriginais.length) {
      return { valid: false, message: MESSAGE_INVALID_PRODUCT };
    }

    $scope.recommendation.produtos = produtosValidos;
    return { valid: true };
  };

  $scope.delete = function() {
    if ($scope.recommendation.id) {
      MessagesService.confirm('Deseja excluir a recomendação?').then(function() {
        $scope.loadingDelete = true;
        RecomendacoesService.deleteCorrecao($scope.recommendation.id).then(function() {
          if ($scope.map) {
            $scope.$emit('history_recommendations');
            $scope.$emit('reload_history');
          } else {
            $route.updateParams({
              activeRecommendationsTab: 'correcaoSolo'
            });
            $timeout(function() {
              $scope.$emit('activateSidebar', 'recommendations');
            });
          }
          MessagesService.alert('Registro excluído com sucesso!');
        }, function() {
          MessagesService.alert('Falha ao excluir o registro.');
        })
          .finally(function() {
            delete $scope.loadingDelete;
          });
      });
    }
  };

  // Grava os dados
  // eslint-disable-next-line max-lines-per-function
  const saveData = function(recommendationId) {
    $scope.loadingSave = true;
    const method = $scope.recommendation.id ? RecomendacoesService.updateCorrecao : RecomendacoesService.saveCorrecao;
    method($scope.recommendation).then(function() {
      if ($scope.map) {
        $scope.$emit('history_recommendations');
      } else {
        $route.updateParams({
          activeRecommendationsTab: 'correcaoSolo'
        });
        $timeout(function() {
          $scope.$emit('activateSidebar', 'recommendations');
          $scope.$emit(EVENT_RELOAD_NOTIFICATIONS);
          $scope.$emit('reloadCalendar');
        });
      }

      MessagesService.alert(`Recomendação ${recommendationId ? 'editada' : 'salva'} com sucesso!`);
    }, function() {
      MessagesService.alert(
        `Não foi possível ${recommendationId ? 'editar' : 'salvar'} a recomendação! Tente novamente!`
      );
    })
      .finally(function() {
        delete $scope.loadingSave;
      });
  };

  // Valida campos é exibe confirmação de edição
  $scope.save = function(form, recommendationId) {
    if (form.$invalid) {
      return;
    }

    const glebasValidas = RecomendacoesService.validateGlebas($scope);

    if (!glebasValidas.valid) {
      MessagesService.alert(glebasValidas.message);
      return;
    }

    const produtosValidos = validateProdutos();

    if (!produtosValidos.valid) {
      MessagesService.alert(produtosValidos.message);
      return;
    }

    if (recommendationId) {
      MessagesService.confirm('Você realmente deseja editar essa recomendação?').then(function() {
        saveData(recommendationId);
      });
      return;
    }
    saveData(recommendationId);
  };

  $scope.duplicate = function() {
    if ($scope.recommendation.id) {
      $scope.modalDuplicacao = $uibModal.open({
        templateUrl: 'views/painel_propriedade/recomendacao/_modal_duplicacao.html',
        scope: $scope
      });
    }
  };

  $scope.closeModalDuplicacao = function() {
    $scope.modalDuplicacao.close();
  };


  function clearRecommendationGlebas() {
    $scope.recommendation.glebas.glebas.forEach(function(gleba) {
      gleba.selected = false;
    });
    $scope.recommendation.glebas = {
      areaTotal: '0',
      glebas: []
    };
    $scope.recommendation.selects.glebas = [];
  }

  $scope.confirmDuplication = function(propriedade) {
    if (propriedade) {
      $scope.recommendation.propriedade = {
        id: propriedade.id,
        descricao: propriedade.descricao,
        glebas: propriedade.glebas
      };
      clearRecommendationGlebas();
      return getGlebasPeriodo($scope.recommendation.propriedade).then(finish);
    }

    if (!$scope.canEdit()) {
      clearRecommendationGlebas();
      return getGlebasPeriodo(null, true).then(finish);
    }

    finish();

    function finish() {
      $scope.recommendation.id = null;
      $scope.recommendation.status = null;
      $scope.recommendation.recomendante = _.find($scope.users, { id: $scope.$root.currentUser.id });
      $scope.modalDuplicacao.close();
      MessagesService.alert('Recomendação Duplicada com sucesso!');
    }
  };

  $scope.reject = function() {
    if ($scope.recommendation.id) {
      $scope.loadingReject = true;
      $scope.$root.rejectRecomendation(null, $scope.recommendation).then(function() {
        $scope.$emit('update_recomendacao');
        $scope.$emit('reload_history');
        MessagesService.alert('Recomendação rejeitada com sucesso!');
      })
        .finally(function() {
          delete $scope.loadingReject;
        });
    }
  };

  $scope.canReject = function() {
    return $scope.recommendation && $scope.recommendation.id &&
      $scope.recommendation.status.descricao !== 'aplicada' &&
      $scope.recommendation.situacao === 'aprovado' &&
      $rootScope.permissions.usuario.CAN_APROVE_RECOMMENDATION;
  };

  $scope.setUnidadePressao = function($event, unidade) {
    $event.preventDefault();
    $scope.recommendation.pressao.unidade = unidade;
  };

  $scope.showApplicationsHistory = function(gleba) {
    if (gleba && $scope.loadingApplicationsGleba !== gleba.id) {
      $scope.loadingApplicationsGleba = gleba.id;

      const filters = {
        gleba: gleba,
        atividade: ($scope.recommendation.atividade || {}).id,
        safra: $scope.recommendation.safra,
        operacao: $rootScope.parametros.operacao_correcao_solo.id
      };

      RecomendacoesService.getPulverizacaoGleba(filters).then(function(data) {
        $scope.historicoAplicacoes = data.data || [];
        $scope.modalAplicacoes = $uibModal.open({
          templateUrl: 'views/painel_propriedade/recomendacao/_modal_aplicacoes.html',
          scope: $scope
        });
      }, function() {
        MessagesService.alert('Não foi possível consultar o histórico de aplicações!');
      })
        .finally(function() {
          $scope.loadingApplicationsGleba = 0;
        });
    }
  };

  $scope.closeApplicationsHistory = function() {
    $scope.modalAplicacoes.close();
  };

  $scope.canEdit = function() {
    return !($scope.recommendation && $scope.recommendation.status) ||
      $scope.recommendation.status.descricao !== 'aplicada';
  };

  const correcaoModalParams = { operacao_item: 'correcao_solo' };

  function fetchCorrecaoProducts(descricao) {
    const params = { ...correcaoModalParams, ...(descricao ? { descricao } : {}) };
    return RecomendacoesService.listItemsBalance(params)
      .then(function(data) {
        return data.data || [];
      });
  }

  function fetchCorrecaoByIds(ids) {
    return RecomendacoesService.listItemsBalance({
      ...correcaoModalParams,
      item: ids.join(','),
      tipo_item: 1
    }).then(function(data) {
      return data.data || [];
    });
  }

  $scope.openProductModal = function() {
    LoadingService.showLoading();
    RecomendacoesService.listItemsBalance(correcaoModalParams)
      .then(function(data) {
        return ProdutoModalService.buildModalList(
          data.data, $scope.recommendation.produtos, fetchCorrecaoByIds
        );
      })
      .then(function(fullList) {
        LoadingService.hideLoading();
        const selectedProducts = ProdutoModalService.findProductSelected(
          fullList, $scope.recommendation.produtos
        );
        return ProdutoModalService.open(fullList, selectedProducts, {
          fetchProducts: fetchCorrecaoProducts
        });
      })
      .then((products) => ProdutoModalService.mergeProducts(products, $scope.recommendation.produtos))
      .then((products) => {
        products.forEach((prod) => $scope.addProduto(prod));
      })
      .catch(function(error) {
        LoadingService.hideLoading();
        if (error) {
          console.error('Erro ao buscar produtos', error);
          MessagesService.alert('Erro ao carregar produtos');
        }
      });
  };

  $scope.$on('addRecommendationCorrecao', function(event, recommendation) {
    initialize(recommendation || $scope.data);
    $scope.$root.initState = null;
  });

  $scope.$on('addRecommendation_close', function() {
    $scope.recommendation = {};
  });

  $scope.$on('update_recomendacao', function() {
    if (Object.keys($scope.recommendation).length > 0) {
      $scope.activeHistoryRecommendations();
    }
  });
});
